import Pagination from '@mui/material/Pagination';

import Button from '@components/button/Button';
import { PAGINATION_LIMIT } from '@constants/generic';

import theme from '../../../themes/colors';

interface CustomTablePaginationProps {
  currentPage: number;
  totalCount: number;
  onPageChange: (count: number) => void;
  isFixed?: boolean;
}

const CustomTablePagination = ({
  currentPage,
  totalCount,
  onPageChange,
  isFixed = true
}: CustomTablePaginationProps) => {
  const pageCount = Math.ceil(totalCount / PAGINATION_LIMIT);

  const handlePageChange = (_event: any, value: number) => {
    onPageChange(value);
  };

  const className = isFixed
    ? 'fixed bottom-0 left-55 flex h-17 w-[calc(100%-220px)] items-center justify-between px-6 bg-cofeeNeutral1'
    : 'flex items-center justify-between mt-3';

  if (pageCount <= 1) return null;

  return (
    <div className={className}>
      <Button
        label="Previous"
        handleClick={() => onPageChange(currentPage - 1)}
        leftIconName="arrow-right-grey"
        variant="tertiary"
        disabled={currentPage === 1}
        className="!h-9 !bg-cofeeNeutral1 !text-sm !font-medium"
        labelStyle={`${
          currentPage === 1 ? '!text-cofeeNeutral5' : '!text-cofeeNeutral10'
        }`}
        leftIconStyle={`rotate-180
          ${
            currentPage === 1
              ? '!stroke-cofeeNeutral5'
              : '!stroke-cofeeNeutral10'
          }
        `}
      />

      <div className="flex items-center justify-center gap-4">
        <Pagination
          count={pageCount}
          page={currentPage}
          onChange={handlePageChange}
          shape="rounded"
          hideNextButton
          hidePrevButton
          siblingCount={1}
          boundaryCount={1}
          sx={{
            '& .MuiPaginationItem-root': {
              border: `1px solid ${theme.cofeeNeutral4}`,
              backgroundColor: theme.cofeeNeutral1,
              color: theme.cofeeNeutral10,
              height: '40px',
              width: '40px',
              placeContent: 'center',
              borderRadius: '8px'
            },
            '& .MuiPaginationItem-root.Mui-selected': {
              border: `1px solid ${theme.cofeePrimary4}`,
              color: theme.cofeePrimary6,
              backgroundColor: theme.cofeeNeutral1
            },
            '& .MuiPaginationItem-root:hover': {
              backgroundColor: theme.cofeeNeutral1
            }
          }}
        />
      </div>

      <Button
        label="Next"
        handleClick={() => onPageChange(currentPage + 1)}
        rightIconName="arrow-right-grey"
        variant="tertiary"
        disabled={currentPage === pageCount}
        className="!mr-2 !h-9 !bg-cofeeNeutral1 !text-sm !font-medium"
        labelStyle={
          currentPage === pageCount
            ? '!text-cofeeNeutral5'
            : '!text-cofeeNeutral10'
        }
        rightIconStyle={
          currentPage === pageCount
            ? '!stroke-cofeeNeutral5'
            : '!stroke-cofeeNeutral10'
        }
      />
    </div>
  );
};

export default CustomTablePagination;
